import { Fragment, ReactElement, useMemo } from 'react';
import { BirthNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { BirthNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { BirthNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { BirthNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { BirthNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchBirthNonResidentNotificationsShared from '../../research-notifications/reasearch-birth-non-resident';

interface ResearchBirthNonResidentNotificationsCivilStatusSharedProps {
  scope?: string;
}

const ResearchBirthNonResidentNotificationsCivilStatusShared = ({
  scope,
}: ResearchBirthNonResidentNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const goBackUrlVisibility: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return BirthNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return BirthNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return BirthNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return BirthNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return BirthNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchBirthNonResidentNotificationsShared
        items={items}
        goBackUrl={goBackUrl}
        goBackUrlVisibility={goBackUrlVisibility}
      />
    </Fragment>
  );
};

ResearchBirthNonResidentNotificationsCivilStatusShared.displayName =
  'Research Birth Non Resident Notifications Civil Status component';

export default ResearchBirthNonResidentNotificationsCivilStatusShared;
